import { render, staticRenderFns } from "./FlowOnlCgformHeadList.vue?vue&type=template&id=9021c71a&scoped=true"
import script from "./FlowOnlCgformHeadList.vue?vue&type=script&lang=js"
export * from "./FlowOnlCgformHeadList.vue?vue&type=script&lang=js"
import style0 from "./FlowOnlCgformHeadList.vue?vue&type=style&index=0&id=9021c71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9021c71a",
  null
  
)

export default component.exports